// Stub: expo-haptics — vibration is not available on desktop/web
const noop = () => Promise.resolve();
export const impactAsync = noop;
export const notificationAsync = noop;
export const selectionAsync = noop;
export const ImpactFeedbackStyle = { Light: 'Light', Medium: 'Medium', Heavy: 'Heavy', Rigid: 'Rigid', Soft: 'Soft' };
export const NotificationFeedbackType = { Success: 'success', Warning: 'warning', Error: 'error' };
export default { impactAsync, notificationAsync, selectionAsync, ImpactFeedbackStyle, NotificationFeedbackType };
